module.exports = {
    "source_code": "HLXEMS",
    "site_id": "onlineprograms.rutgers.edu",
    "title": "Rutgers, The State University of New Jersey",
    "tfn": "",
    "url": "https://onlineprograms.rutgers.edu",
    "gtm_code": "GTM-T445PB87",
}